export const home = {
  'hero.eyebrow': 'CSSBuy Spreadsheet • Produkte • Ratgeber • QC • Versand',
  'hero.h1': 'CSSBuy Spreadsheet: Produkte, Links & Ratgeber an einem Ort',
  'hero.subtitle': 'Entdecken Sie das CSSBuy Spreadsheet, finden Sie Produkte und Links, vergleichen Sie Optionen und finden Sie praktische Informationen zu QC, Lager, Versandkosten und internationalem Einkauf.',
  'hero.cta.primary': 'CSSBuy Spreadsheet erkunden',
  'hero.cta.secondary': 'CSSBuy Ratgeber ansehen',
  'hero.trust': 'Organisierte Informationen • Praktische Ratgeber • Klare Vergleiche • Aktualisierter Inhalt',

  'spreadsheet.h2': 'Ihr Ausgangspunkt für das CSSBuy Spreadsheet',
  'spreadsheet.text': 'Produkte zu finden und internationales Einkaufen zu verstehen, kann verwirrend sein. Wir organisieren Informationen, Links, Ratgeber und Vergleiche zu CSSBuy an einem Ort, um Ihnen zu helfen, besser zu recherchieren und fundiertere Entscheidungen zu treffen.',
  'spreadsheet.cta': 'CSSBuy Spreadsheet erkunden',

  'what.h2': 'Was ist das CSSBuy Spreadsheet?',
  'what.text': 'Das CSSBuy Spreadsheet ist eine praktische Möglichkeit, Produkte, Links und Informationen zu CSSBuy zu organisieren und zu recherchieren. Sie können Kategorien vergleichen, verfügbare Informationen prüfen und Ratgeber zu QC, Lagerung und Versand finden, bevor Sie eine Entscheidung treffen.',

  'how.h2': 'So verwenden Sie das CSSBuy Spreadsheet',
  'how.step1.title': 'Ein Produkt finden',
  'how.step1.desc': 'Suchen Sie nach der gewünschten Kategorie oder dem Produkt.',
  'how.step2.title': 'Informationen prüfen',
  'how.step2.desc': 'Überprüfen Sie Beschreibung, Verkäufer, Preis und Verfügbarkeit.',
  'how.step3.title': 'Optionen vergleichen',
  'how.step3.desc': 'Vergleichen Sie Produkte mit organisierten Informationen.',
  'how.step4.title': 'QC prüfen',
  'how.step4.desc': 'Lernen Sie, was bei Fotos und Inspektionen zu prüfen ist.',
  'how.step5.title': 'Versand analysieren',
  'how.step5.desc': 'Berücksichtigen Sie Gewicht, Volumen, Ziel und Methode.',
  'how.step6.title': 'Eine fundierte Entscheidung treffen',
  'how.step6.desc': 'Bestätigen Sie immer die aktuellen Informationen vor dem Kauf.',

  'categories.h2': 'Beliebte Kategorien im CSSBuy Spreadsheet',
  'categories.cta': 'Alle Kategorien ansehen',

  'guides.h2': 'Beliebteste CSSBuy Ratgeber',
  'guides.cta': 'Alle Ratgeber ansehen',

  'shipping.h2': 'CSSBuy Versandkosten: Kosten verstehen',
  'shipping.text': 'Die Versandkosten können je nach Gewicht, Volumen, Zielort, Versandmethode und aktuellen Bedingungen variieren. Erfahren Sie, welche Faktoren den Preis beeinflussen können, bevor Sie eine Bestellung abschließen.',
  'shipping.cta': 'CSSBuy Versandkosten ansehen',

  'qc.h2': 'CSSBuy QC: Wissen, was zu prüfen ist',
  'qc.checks': 'Fotos, Größe, Farbe, Nähte, Details, Mögliche Mängel, Menge, Verpackung',
  'qc.cta': 'Über QC lernen',

  'review.h2': 'CSSBuy Review: Was analysieren',
  'review.table.factor': 'Faktor',
  'review.table.check': 'Was zu prüfen ist',
  'review.cta': 'CSSBuy Review lesen',

  'safety.h2': 'Ist CSSBuy legitim?',
  'safety.text': 'Bevor Sie einen internationalen Service nutzen, prüfen Sie die Domain, Richtlinien, Zahlungen, Versandbedingungen und aktuelle Informationen. Verlassen Sie sich nicht nur auf Bewertungen oder Angebote von Dritten.',
  'safety.cta': 'Sicherheitsratgeber ansehen',

  'faq.h2': 'Häufig gestellte Fragen zum CSSBuy Spreadsheet',
  'faq.cta': 'Alle FAQ ansehen',

  'final.h2': 'Bereit, das CSSBuy Spreadsheet zu erkunden?',
  'final.text': 'Beginnen Sie Ihre Recherche, finden Sie nützliche Ressourcen und wechseln Sie zu unserer Hauptwebsite, wenn Sie bereit sind.',
  'final.cta': 'CSSBuy Spreadsheet erkunden',

  'nav.home': 'Startseite',
  'nav.guides': 'Ratgeber',
  'nav.shoppingGuide': 'Einkaufsführer',
  'nav.categories': 'Kategorien',
  'nav.review': 'Review',
  'nav.shipping': 'Versand',
  'nav.qc': 'QC',
  'nav.safety': 'Sicherheit',
  'nav.faq': 'FAQ',
  'nav.article': 'Artikel',
  'nav.lang': 'Sprache',

  'cta.main1': 'CSSBuy Spreadsheet',
  'cta.main2': 'Jetzt kaufen',
  'cta.view': 'Kategorie ansehen',
  'cta.explore': 'Erkunden',
  'cta.read': 'Artikel lesen',

  'footer.about': 'Über uns',
  'footer.policy': 'Redaktionsrichtlinien',
  'footer.contact': 'Kontakt',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.disclaimer': 'Diese Website ist eine unabhängige Informationsressource und ist nicht mit CSSBuy verbunden oder von CSSBuy unterstützt, es sei denn, dies wird ausdrücklich angegeben.',
  'footer.rights': 'Alle Rechte vorbehalten.',

  'notFound.title': 'Seite nicht gefunden',
  'notFound.subtitle': 'Die Seite, die Sie suchen, existiert nicht. Kehren Sie zur Startseite zurück und erkunden Sie weiter.',
  'notFound.back': 'Zurück zur Startseite',

  'article.title': 'CSSBuy Spreadsheet Ratgeber 2026 — So finden Sie Produkte und kaufen mit Vertrauen',
  'article.meta': 'Erfahren Sie, wie Sie das CSSBuy Spreadsheet verwenden, um Produkte zu finden, Links zu verifizieren, Versandkosten zu verstehen und fundierte Entscheidungen beim internationalen Einkauf zu treffen.',
  'article.author': 'CSSBuy Spreadsheet Team',
  'article.published': 'Veröffentlicht am 30. August 2026',
  'article.updated': 'Aktualisiert am 30. August 2026',
  'article.toc': 'Inhalt',
  'article.takeaways': 'Wichtige Erkenntnisse',
  'article.faq': 'Häufig gestellte Fragen',
  'article.related': 'Verwandte Artikel',
  'article.back': 'Zurück zur Startseite',
  'article.notFound': 'Artikel nicht gefunden.',

  'pillar.h2': 'CSSBuy Ratgeber & Artikel',
  'pillar.subtitle': 'Entdecken Sie unsere detaillierten Ratgeber zum CSSBuy Spreadsheet zu Review, Versand, QC, Lager, Gutscheinen und Vergleichen.',
  'pillar.read': 'Artikel lesen',
};

export default home;